import { render, staticRenderFns } from "./ManageAnswers.vue?vue&type=template&id=a3817464&scoped=true&"
import script from "./ManageAnswers.vue?vue&type=script&lang=js&"
export * from "./ManageAnswers.vue?vue&type=script&lang=js&"
import style1 from "../../../node_modules/vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3817464",
  null
  
)

export default component.exports